import {
    createCTRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';
import {
    ClaimCodeResponse,
    ReferAFriendEligibility,
    ReferAFriendInfo,
    ReferAFriendStatus,
} from '@models/referAFriend/types';
import { getConfig } from '@superbet-group/web.lib.config';
import { removeLeadTrailSlashes } from '@superbet-group/web.lib.utilities';
import { getClientSourceParam } from '@superbet-group/web.lib.vue-utilities';
import { getCsrfToken } from '@core/services/authentication/helpers';

const defaultHttpTimeoutMs = 60 * 1000;

export class ReferAFriendService {
    private client: RestClient;

    constructor(client: RestClient) {
        this.client = client;
    }

    getInfo(): Promise<ReferAFriendInfo> {
        return this.client.get<ReferAFriendInfo>('/getInfo');
    }

    getStatus(username?: string | null): Promise<ReferAFriendStatus> {
        return this.client.get<ReferAFriendStatus>(`/getStatus?username=${username || ''}`);
    }

    getEligibility(): Promise<ReferAFriendEligibility> {
        return this.client.get<ReferAFriendEligibility>('/getEligibility');
    }

    redeemCode({ code, username }: { code: string; username?: string }): Promise<boolean> {
        return this.client
            .post('/redeemCode', { code, username })
            .then(() => true)
            .catch(() => false);
    }

    claimCode(body: { referee?: string | null }): Promise<boolean | ClaimCodeResponse> {
        return this.client
            .post('/claimCode', body)
            .then((response) => (response as ClaimCodeResponse))
            .catch(() => false);
    }
}

export const referAFriendService: ReferAFriendService = new ReferAFriendService(
    createCTRestClient(
        `${removeLeadTrailSlashes(getConfig().country.host)}/api-gw/loyalty`,
        defaultHttpTimeoutMs,
        getClientSourceParam(),
        true,
        getCsrfToken,
    ),
);
